// src/components/Sidebar.js
import React, { useEffect, useState } from "react";
import "./Sidebar.css";
import Logofull from "../assets/FullLogo.png";
import Logo from "../assets/Logo.png";
import { Link, useNavigate } from 'react-router-dom';
import { logout } from "../utils/api";
import { AxiosError } from "./sessionexpiry";
import { makeAuthenticatedRequest } from "../utils/api";
import { decrypt, encrypt } from "../utils/cryptoUtils"; // Import encryption utilities
import { useDispatch, useSelector } from "react-redux";
import { login_users_realtime_details } from "../redux/LoginSlice";

const Sidebar = ({ isSidebarCollapsed, toggleSidebar, isMobile }) => {
  const [openDropdown, setOpenDropdown] = useState(null);
  const [responseData, setResponseData] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const users = JSON.parse(sessionStorage.getItem("users"));
  const Screen_no = users?.userdatils?.Screen_no || 0;

  const toggleDropdown = (dropdownmenu) => {
    setOpenDropdown(prev => prev === dropdownmenu ? null : dropdownmenu);
  };

  useEffect(() => {
    const postData = async () => {
      try {
        const accessToken = sessionStorage.getItem("token"); // Retrieve token

        const requestData = JSON.stringify({
          Dname: "merchant",
          Tname: "users u",
          Cname: ["u.id", "name", "screen_no", "email", "business_name", "mobile", "profile_pic", "u.business_type", "bt.business_type", "u.created_at"], // Updated field names
          Jtype: "inner join",
          Jcondition: {
            "merchant.business_type bt": "u.business_type=bt.id",
          },
          Where: [
            {
              column: "accesstoken",
              operator: "=",
              value: accessToken
            },
          ],
          Limit: "10",
          Offset: "0",
        });

        const encrypted = encrypt(requestData);

        const data = await makeAuthenticatedRequest("POST", "/fetch", { encrypted }, navigate);
        const decryptdata = decrypt(data);
        const fixedString = decryptdata.replace(/\\"/g, '"');

        // Convert to array
        const jsonArray = JSON.parse(fixedString);

        dispatch(login_users_realtime_details(jsonArray)); // Pass the entire response  

        setResponseData(jsonArray);
      } catch (err) {
        AxiosError(navigate, error)
        setError(err.message);
      }
    };

    postData();
  }, [dispatch]);

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      AxiosError(navigate, error);
      console.error("Logout error:", error.message);
    }
  };

  return (
    <>

      {/* Mobile overlay */}
      {isMobile && !isSidebarCollapsed && (
        <div
          className="fixed inset-0 z-40 lg:hidden"
          onClick={toggleSidebar}
        />
      )}

      <div className={`${isSidebarCollapsed ? "sidebar-collapsed" : "sidebar-open"}`}>
        <aside
          className={`sidebar border border-r ${isSidebarCollapsed ? "collapsed" : ""
            } ${isMobile ? `fixed z-50 h-full transition-transform duration-300 ${isSidebarCollapsed ? "-translate-x-full" : "translate-x-0"
              }` : ""
            }`}
        >
          {/* Sidebar Header */}
          <header className="sidebar-header flex items-center">
            <a href="#" className="flex items-center w-[180px]">
              <img
                src={Logofull}
                alt="Full Logo"
                className={`full-logo ${isSidebarCollapsed ? "hidden" : "block"}`}
              />
              <img
                src={Logo}
                alt="Small Logo"
                className={`small-logo ${isSidebarCollapsed ? "block" : "hidden"}`}
              />
            </a>

            {!isMobile && (
              <button
                className="sidebar-toggler"
                onClick={toggleSidebar}
                aria-label={isSidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"}
              >
                <span className="material-symbols-rounded">chevron_left</span>
              </button>
            )}
          </header>

          <nav className="sidebar-nav">
            {/* Primary Top Nav */}
            <ul className="nav-list primary-nav">
              <li className="nav-item">
                <Link to="/dashboard" className="nav-link" onClick={() => isMobile && toggleSidebar()}>
                  <span className="material-symbols-rounded">dashboard</span>
                  <span className="nav-label">Dashboard</span>
                </Link>
              </li>
              {Screen_no === 1 && (
                <li className="nav-item">
                  <Link to="/Initiatepayout" className="nav-link" onClick={() => isMobile && toggleSidebar()}>
                    <span className="material-symbols-rounded">payments</span>
                    <span className="nav-label">payouts</span>
                  </Link>
                </li>
              )}

              {/* {Screen_no === 1 && (
                <li className={`nav-item dropdown-container ${openDropdown === "payouts" ? "open" : ""}`}>
                  <a
                    href="#"
                    className="nav-link dropdown-toggle"
                    onClick={() => toggleDropdown("payouts")}
                    aria-expanded={openDropdown === "payouts"}
                  >
                    <span className="material-symbols-outlined">payments</span>
                    <span className="nav-label">Payouts</span>
                  </a>
                  <ul className="dropdown-menu">
                    <li className="nav-item">
                      <Link
                        to="/Fundload"
                        className="nav-link dropdown-link"
                        onClick={() => isMobile && toggleSidebar()}
                      >
                        Fund History
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        to="/Payout"
                        className="nav-link dropdown-link"
                        onClick={() => isMobile && toggleSidebar()}
                      >
                        Payouts
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        to="/Initiatepayout"
                        className="nav-link dropdown-link"
                        onClick={() => isMobile && toggleSidebar()}
                      >
                        Initiate Payout
                      </Link>
                    </li>
                  </ul>
                </li>
              )} */}

              {/* {Screen_no === 1 && (
                <li className="nav-item">
                  <Link 
                    to="/Invoice" 
                    className="nav-link"
                    onClick={() => isMobile && toggleSidebar()}
                  >
                    <span className="material-symbols-outlined">receipt_long</span>
                    <span className="nav-label">Invoice</span>
                  </Link>
                </li>
              )} */}

              <li className="nav-item">
                <Link
                  to="/Kyc"
                  className="nav-link"
                  onClick={() => isMobile && toggleSidebar()}
                >
                  <span className="material-symbols-outlined">badge</span>
                  <span className="nav-label">KYC</span>
                </Link>
              </li>

              {/* {Screen_no === 1 && (
                <li className="nav-item">
                  <Link 
                    to="/Reports" 
                    className="nav-link"
                    onClick={() => isMobile && toggleSidebar()}
                  >
                    <span className="material-symbols-outlined">download</span>
                    <span className="nav-label">Reports</span>
                  </Link>
                </li>
              )} */}

              {Screen_no === 1 && (
                <li className="nav-item">
                  <Link
                    to="/DeveloperTools"
                    className="nav-link"
                    onClick={() => isMobile && toggleSidebar()}
                  >
                    <span className="material-symbols-outlined">integration_instructions</span>
                    <span className="nav-label">Developer Tools</span>
                  </Link>
                </li>
              )}
            </ul>

            {/* Secondary Bottom Nav */}
            <ul className="nav-list secondary-nav">
              {/* <li className="nav-item">
                <Link to="/support" className="nav-link" onClick={() => isMobile && toggleSidebar()}>
                  <span className="material-symbols-rounded">help</span>
                  <span className="nav-label">Support</span>
                </Link>
              </li> */}
              <li className="nav-item">
                <a className="nav-link cursor-pointer" onClick={handleLogout}>
                  <span className="material-symbols-rounded">logout</span>
                  <span className="nav-label">Sign Out</span>
                </a>
              </li>
            </ul>
          </nav>
        </aside>
      </div>
    </>
  );
};

export default Sidebar;